(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/bomben-button.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/bomben-button.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.tipset.views.BombenButton = Backbone.Marionette.View.extend({
    log: new svs.core.log.Logger('svs.tipset.views.BetslipBomben'),

    ui: {
      bombenBtn: '.js-bomben-game'
    },
    events: {
      'click @ui.bombenBtn': 'playBomben'
    },
    modelEvents: {
      change: 'render'
    },

    template: function(data) {
      return svs.tipset.templates.bombenbutton(data);
    },

    playBomben: function() {
      if (!this.model.get('missingBomben')) {
        var buttonClass = 'btn-transparent-inverted';
        if (!this.model.missingBomben) {
          svs.components.Modal.show(
            svs.tipset.views.BombenGame,
            { model: svs.tipset.models.bombenXperten },
            {
              title: 'Spela Bomben',
              headerClass:
                svs.tipset.models.gameDefinitions.get('htmlClass') +
                '-modal-header',
              leftButton: {
                visible: true,
                cssClass: buttonClass
              },
              rightButton: {
                visible: true,
                disabled: true,
                text: 'Klar',
                cssClass: buttonClass,
                callback: function() {
                  svs.tipset.models.bombenXperten.bombenDone();
                  return true;
                }
              }
            }
          );
        }
      }
    }
  });
})(svs);

 })(window);